import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center p-12">
      <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-blue-600" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <span className="ml-3 text-gray-600">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;